export default {
	symbolsKeyValue: '.?!&',
	layout: [
		['=', '+', '%', '*', '[', ']', '{', '}', '<', '>'],
		['@', ':', ';', '_', '-', '#', '(', ')', '/', '\\'],
		['.', ',', '&', '$', '?', '!', '\'', '"', '^'],
	]
};
